<script>
import { Popup, Picker, Cell, CellGroup, Icon, Search } from "vant";
import cloneDeep from "lodash/cloneDeep";
import isEqual from "lodash/isEqual";

export default {
  name: "popupMultiple",
  components: {
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Icon.name]: Icon,
    [Search.name]: Search,
  },
  props: {
    search: {
      type: Boolean,
      default: false,
    },
    searchFilter: {
      type: [String, Array, Function],
      default: () => ["text", "simpleCode"],
    },
    searchPlaceholder: {
      type: String,
      default: "",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    keys: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
    keyField: {
      type: String,
      default: "Id",
    },
    textField: {
      type: String,
      default: "Name",
    },
    disabledField: {
      type: String,
      default: "disabled",
    },
    isConfirm: {
      type: Boolean,
      default: true,
    },
    confirmButtonText: {
      type: String,
      default: "确认",
    },
    cancelButtonText: {
      type: String,
      default: "取消",
    },
    max: {
      type: [String, Number],
      default: null,
    },
    maxRequired: {
      type: String,
      default: "最大选择数量:",
    },
    maxHeight: {
      type: String,
      default: "60vh",
    },
    getContainer: {
      type: String,
      default: "#app",
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      copyKeys: [],
      defaultColumns: [],
      visibleColumns: [],
      searchValue: "",
      valueList: [],
    };
  },
  model: {
    prop: "visible",
  },
  watch: {
    visible() {
      this.searchValue = "";
    },
    columns() {
      this.copyData();
    },
    keys(val) {
      if (!isEqual(this.copyKeys, val)) {
        this.copyKeys = val;
        this.copyData();
      }
    },
  },
  computed: {},
  created() {
    this.copyData();
  },
  methods: {
    copyData() {
      let { columns, keys, keyField } = this;
      let defaultColumns = cloneDeep(columns);
      let copyKeys = [];
      defaultColumns.map(p => {
        p.isChecked = keys && keys.includes(p[keyField]);
        if (p.isChecked) copyKeys.push(p[keyField]);
      });
      this.defaultColumns = defaultColumns;
      this.visibleColumns = defaultColumns;
      this.copyKeys = copyKeys;
      this.valueList = cloneDeep(copyKeys);
    },
    onSearch() {
      let that = this;
      that.$nextTick(() => {
        let { searchValue, searchFilter, defaultColumns } = that;
        if (searchValue && searchFilter) {
          if (typeof searchFilter == "string") {
            that.visibleColumns = defaultColumns.filter(p => {
              return (
                p[searchFilter] &&
                p[searchFilter]
                  .toLowerCase()
                  .indexOf(searchValue.toLowerCase()) > -1
              );
            });
          } else if (searchFilter instanceof Array) {
            that.visibleColumns = defaultColumns.filter(p => {
              return searchFilter.find(
                o =>
                  p[o] &&
                  p[o].toLowerCase().indexOf(searchValue.toLowerCase()) > -1,
              );
            });
          } else {
            that.visibleColumns = defaultColumns.filter(p => searchFilter(p));
          }
        } else {
          that.visibleColumns = defaultColumns;
        }
      });
    },
    checked(row) {
      let { isConfirm, max, maxRequired, visibleColumns, disabledField } = this;
      if (row[disabledField]) return false;
      if (max && !row.isChecked) {
        let len = 0;
        visibleColumns.map(p => {
          if (p.isChecked) {
            len++;
          }
        });
        if (max <= len) {
          this.$notify({ type: "danger", message: maxRequired + max });
          return false;
        }
      }
      let { valueList, keyField } = this;
      row.isChecked = !row.isChecked;
      if (row.isChecked) {
        this.valueList.push(row[keyField]);
      } else {
        this.valueList = valueList.filter(el => el != row[keyField]);
      }
      if (!isConfirm) {
        this.valueUpdate(this.getValue());
      }
    },
    getValue() {
      let { defaultColumns, keyField } = this;
      let keys = [];
      defaultColumns.map(p => {
        if (p.isChecked) keys.push(p[keyField]);
      });
      return keys;
    },
    valueUpdate(value) {
      // this.copyKeys = value;
      this.$emit("update:keys", value, this.valueList);
      this.$emit("confirm", value, this.valueList);
    },
    confirm() {
      this.$emit("input", false);
      this.valueUpdate(this.getValue());
    },
    cancel() {
      const { defaultColumns, disabledField, keyField } = this;
      let disableKeys = [];
      let keys = cloneDeep(this.copyKeys);
      defaultColumns.forEach(p => {
        if (p[disabledField]) {
          disableKeys.push(p[keyField]);
        }
      });
      for (let i = 0; i < keys.length; i++) {
        if (!disableKeys.includes(keys[i])) {
          keys.splice(i, 1);
          i--;
        }
      }

      this.$emit("input", false);
      this.$emit("update:keys", keys);
      this.$nextTick(() => {
        this.copyData();
      });
    },
    popupRender() {
      const option = {
        props: {
          position: "bottom",
          value: this.visible,
          "get-container": "#app",
          closeOnClickOverlay: this.closeOnClickOverlay,
        },
        style: {
          maxHeight: `calc(${this.maxHeight} + ${
            this.search ? "54px" : "0px"
          })`,
          // height: "100%"
        },
        on: {
          input: val => {
            this.$emit("input", val);
          },
        },
      };
      return (
        <van-popup {...option}>
          {this.confirmRender()}
          {this.searchRender()}
          {this.multipleRender()}
        </van-popup>
      );
    },
    searchRender() {
      let that = this;
      if (that.search) {
        let { searchValue, searchPlaceholder } = that;
        return (
          <van-search
            {...{
              class: "search",
              props: {
                value: searchValue,
                placeholder: searchPlaceholder,
              },
              on: {
                input: e => {
                  that.searchValue = e;
                  that.onSearch();
                },
              },
            }}
          />
        );
      }
    },
    multipleRender() {
      return (
        <div
          {...{
            style: {
              height: `calc(${this.maxHeight} - 44px - ${
                this.search ? "54px" : "0"
              })`,
              minHeight: `calc(${this.maxHeight} - 44px - ${
                this.search ? "54px" : 0
              })`,
              overflow: "auto",
            },
          }}
        >
          <van-cell-group
            {...{
              class: "list",
            }}
          >
            {this.cellRender()}
          </van-cell-group>
        </div>
      );
    },
    cellRender() {
      const { visibleColumns, textField, disabledField } = this;
      return visibleColumns.map(p => {
        let option = {
          class: { item: true, disabled: p[disabledField] },
          on: {
            click: () => this.checked(p),
          },
          scopedSlots: {
            title: () => {
              return (
                <div>
                  {p[textField]}
                  {p.isChecked ? this.checkIconRender(p) : ""}
                </div>
              );
            },
          },
        };
        return <van-cell {...option} />;
      });
    },
    checkIconRender() {
      return <van-icon name="checked" class="icon-success" />;
    },
    confirmRender() {
      if (this.isConfirm) {
        return (
          <div class="select-head van-hairline--top-bottom van-picker__toolbar">
            <button class="van-picker__cancel" onClick={this.cancel}>
              {this.cancelButtonText}
            </button>
            <button class="van-picker__confirm" onClick={this.confirm}>
              {this.confirmButtonText}
            </button>
          </div>
        );
      }
    },
  },
  render() {
    return this.popupRender();
  },
};
</script>

<style lang="less" scoped>
/deep/.search .van-cell__value {
  text-align: left;
  line-height: initial;
  .van-field__body {
    display: flex;
  }
}
.list {
  .item {
    position: relative;
    padding-right: 40px;
    .icon-success {
      position: absolute;
      right: 15px;
      top: 13px;
      color: green;
      font-size: 20px;
    }
    &.disabled {
      background: #f1f1f1;
    }
  }
}
</style>
